import * as THREE from 'three';
import {applyShadows} from 'components/customer/RoomPlanner/helpers/shadows';

type AdvancedShelfMeshes = THREE.Object3D | THREE.Object3D[] | null | undefined;

/**
 * Adds advanced-shelf meshes when they finish loading without blocking the
 * cabinet group from entering the scene. Template panels from createPanelGeometry
 * can appear as soon as their textures resolve.
 * @param {THREE.Group} cabinetGroup Target cabinet group.
 * @param {AdvancedShelfMeshes | Promise<AdvancedShelfMeshes>} meshesOrPromise Resolved shelf meshes.
 */
export const attachAdvancedShelfMeshes = (
    cabinetGroup: THREE.Group,
    meshesOrPromise: AdvancedShelfMeshes | Promise<AdvancedShelfMeshes>
): void => {
    void Promise.resolve(meshesOrPromise)
        .then((meshes) => {
            if (!meshes) return;
            const meshList = Array.isArray(meshes) ? meshes : [meshes];
            if (meshList.length === 0) return;

            // These land after renderCabinetGroup has already applied
            // shadows to the group, so they need their own pass.
            meshList.forEach((mesh) => applyShadows(mesh));
            cabinetGroup.add(...meshList);
        })
        .catch(() => undefined);
};
